// Import modułów dla poszczególnych stron
import homepage from './routes/homepage';
import dlaFirm from './routes/dla-firm';
import serwis from './routes/serwis';
import oNas from './routes/o-nas';
import shop from './routes/shop';
import product from './routes/product';
import productV2 from './routes/product-v2';
import checkout from './routes/checkout';
import account from './routes/account';
import cart from './routes/cart';
import blog from './routes/blog';

/**
 * Główny obiekt inicjalizujący funkcjonalności strony
 */
export default {
    init() {
        try {
            // Inicjalizacja klasy body
            $('body').attr('class', $('#body-classes').addClass('loaded').attr('class'));

            // Router dla modułów na podstawie klasy body
            this.initializeRouting();

            // Inicjalizacja podstawowych komponentów
            initializeUIComponents();

            // Warunkowa inicjalizacja menu (Mega Menu lub standardowe)
            const megaMenuEnabled = document.body.classList.contains('mega-menu-active');
            
            if (megaMenuEnabled) {
                // Mega Menu - Desktop
                initializeMegaMenu();
                // Mega Menu - Mobile (używa podobnej logiki co standardowe menu mobilne)
                initializeMobileMenu();
                initializeMegaMenuMobileDropdowns();
            } else {
                // Standardowe menu
                initializeMenu();
                initializeMobileMenu();
                initializeMobileMenuDropdowns();
            }
            
            initializeResizeHandlers();
        } catch (error) {
            // Fallback dla krytycznych błędów inicjalizacji
            console.error('Critical initialization error:', error);
            // Próba ponownej inicjalizacji podstawowych funkcjonalności
            initializeUIComponents();
            initializeMenu();
        }
    },

    initializeRouting() {
        const body = document.body;
        const routes = {
            'home': homepage,
            'page-template-template-firmy': dlaFirm,
            'page-template-template-serwis': serwis,
            'page-template-template-onas': oNas,
            // Nowa karta ma własny moduł; wybór zależy od tego, który szablon
            // wyrenderował serwer (przełącznik IK_PDP_V2).
            'single-product': document.querySelector('.pdp') ? productV2 : product,
            'woocommerce-account': account,
            'woocommerce-checkout': checkout,
            'woocommerce-cart': cart,
            'single-post': blog,
        };

        // Inicjalizacja odpowiedniego modułu
        for (const [className, module] of Object.entries(routes)) {
            if (body.classList.contains(className)) {
                module.init();
                return;
            }
        }

        // Obsługa stron archiwum, kategorii i tagów produktów
        if (body.classList.contains('post-type-archive') ||
            body.classList.contains('tax-product_cat') ||
            body.classList.contains('tax-product_tag')) {
            shop.init();
        }
    },
};

/**
 * Inicjalizacja komponentów UI
 */
function initializeUIComponents() {
    try {
        // Czyszczenie tekstu dla przycisków zamykania
        $('.yith-wacp-close').text('');
    } catch (error) {
        console.error('UI components initialization error:', error);
    }
}

 
/**
* Inicjalizacja menu
*/
function initializeMenu() {
    try {
        if (window.matchMedia('(min-width: 991px)').matches) {
            navbarStickyInit();
            initializeMenuListeners();
        }
    } catch (error) {
        console.error('Menu initialization error:', error);
        // Fallback do podstawowej funkcjonalności menu
        initializeBasicMenu();
    }
 }
 
 /**
 * Inicjalizacja podstawowej funkcjonalności menu (fallback)
 */
 function initializeBasicMenu() {
    $('.nav-link.dropdown-toggle').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('show');
        $(this).next().toggleClass('show');
    });
 }
 
 /**
 * Inicjalizacja nasłuchiwania menu
 */
 function initializeMenuListeners() {
    // Nasłuchiwanie na scroll. Scrolluje BODY (nie document), a zdarzenie
    // scroll nie bąbelkuje - bez capture handler nigdy by nie odpalił.
    const throttledScroll = throttle(navbarStickyInit, 100);
    document.addEventListener('scroll', throttledScroll, { passive: true, capture: true });
 
    // Obsługa hover na elementach menu
    initializeMenuHoverBehavior();
 }
 
 /**
 * Inicjalizacja zachowania menu przy hover
 */
 function initializeMenuHoverBehavior() {
    // Obsługa hover na linkach dropdown
    $('.nav-link.dropdown-toggle').hover(
        function() {
            const $this = $(this);
            $this.removeAttr('data-bs-toggle');
            $this.parent().addClass('show');
            $this.next().addClass('show');
        },
        function() {
            const $this = $(this);
            const $next = $this.next();
            
            if (!isElementHovered($next) && !isElementHovered($this)) {
                $this.attr('data-bs-toggle', 'dropdown');
                $this.parent().removeClass('show');
                $next.removeClass('show');
            }
        }
    );
 
    // Obsługa hover na menu dropdown
    $('.dropdown-menu').hover(
        () => {},
        function() {
            const $this = $(this);
            const $prev = $this.prev();
            
            if (!isElementHovered($prev) && !isElementHovered($this)) {
                $this.parent().removeClass('show');
                $this.removeClass('show');
            }
        }
    );
 }
 
 /**
 * Sprawdzenie czy element jest aktualnie najechany
 * @param {jQuery} $element - Element jQuery do sprawdzenia
 * @returns {boolean}
 */
 function isElementHovered($element) {
    return $element.filter(':hover').length > 0;
 }
 
 /**
 * Funkcja throttle dla optymalizacji wydajności
 * @param {Function} func - Funkcja do throttle
 * @param {number} limit - Limit czasu w ms
 * @returns {Function}
 */
 function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
 }
 
/**
 * Inicjalizacja menu mobilnego
 */
function initializeMobileMenu() {
    const mobileMenu = document.getElementById('mobile-menu');
    const mainNavigation = document.getElementById('main-navigation');
    
    if (!mobileMenu || !mainNavigation) return;
    
    // Add 'open' class when mobile menu is shown
    mobileMenu.addEventListener('show.bs.collapse', function() {
        mainNavigation.classList.add('open');
        // Prevent body scrolling
        document.body.style.overflow = 'hidden';
    });
    
    // Remove 'open' class when mobile menu is hidden
    mobileMenu.addEventListener('hide.bs.collapse', function() {
        mainNavigation.classList.remove('open');
        // Restore body scrolling
        document.body.style.overflow = '';
    });
}

/**
 * Inicjalizacja zachowania dropdownów w menu mobilnym
 */
function initializeMobileMenuDropdowns() {
    const $mobileMenus = $('#menu-menu-mobile-2, #menu-menu-mobile-2-en');

    // Use capture phase to handle second level clicks BEFORE Bootstrap intercepts them
    document.addEventListener('click', function(e) {
        const target = e.target;
        const link = target.closest('a');
        
        // Check if click is on a second level item (inside depth_0 menu)
        if (link) {
            const parentLi = link.parentElement;
            const secondLevelMenu = link.closest('ul.dropdown-menu.depth_0');
            const mobileMenu = link.closest('#menu-menu-mobile-2, #menu-menu-mobile-2-en');
            
            // Only handle clicks inside mobile menu's second level
            if (secondLevelMenu && mobileMenu) {
                // Check if this item has children (third level)
                if (parentLi.classList.contains('menu-item-has-children')) {
                    // Prevent default and stop propagation
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Toggle the third level submenu
                    const submenu = parentLi.querySelector(':scope > ul.dropdown-menu');
                    if (submenu) {
                        submenu.classList.toggle('show');
                        
                        // Toggle aria-expanded
                        link.setAttribute('aria-expanded', submenu.classList.contains('show'));
                        
                        // Update second level states
                        updateSecondLevelStatesNative(secondLevelMenu);
                    }
                    
                    // Update first level states
                    updateMenuActiveStates($(mobileMenu));
                }
            }
        }
    }, true); // true = capture phase

    // Handle clicks anywhere to update first level states
    $(document).on('click', function() {
        const $menus = $('#menu-menu-mobile-2, #menu-menu-mobile-2-en');
        setTimeout(function() {
            $menus.each(function() {
                updateMenuActiveStates($(this));
            });
        }, 150);
    });

    // Handle clicks on third level items (depth_1)
    $mobileMenus.on('click', '.dropdown-menu.depth_1 > li > a', function(e) {
        // Allow navigation but prevent closing parent menus
        e.stopPropagation();
    });

    // Prevent clicks inside dropdown menus from closing parent dropdowns
    $('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });

    // Initial state check
    updateMenuActiveStates($mobileMenus.first());
}

/**
 * Aktualizacja stanów drugiego poziomu menu (native JS)
 * @param {Element} secondLevelMenu - Element UL menu drugiego poziomu (depth_0)
 */
function updateSecondLevelStatesNative(secondLevelMenu) {
    const items = secondLevelMenu.querySelectorAll(':scope > li');
    
    // Check if any item has open third level
    let hasOpenThirdLevel = false;
    items.forEach(function(item) {
        const submenu = item.querySelector(':scope > ul.dropdown-menu.show');
        if (submenu) {
            hasOpenThirdLevel = true;
        }
    });
    
    // Clear previous classes
    items.forEach(function(item) {
        item.classList.remove('is-active', 'is-inactive');
    });
    
    // Add classes if any third level is open
    if (hasOpenThirdLevel) {
        items.forEach(function(item) {
            const submenu = item.querySelector(':scope > ul.dropdown-menu.show');
            if (submenu) {
                item.classList.add('is-active');
            } else {
                item.classList.add('is-inactive');
            }
        });
    }
}

/**
 * Aktualizacja stanów aktywnych elementów menu
 * @param {jQuery} $menu - Element menu
 */
function updateMenuActiveStates($menu) {
    const $firstLevelItems = $menu.children('li');
    
    // Check if any first level item has an open dropdown
    const hasActiveItem = $firstLevelItems.filter(function() {
        return $(this).find('> .dropdown-menu.show').length > 0;
    }).length > 0;
    
    // Always clear previous states first
    $firstLevelItems.removeClass('is-active is-inactive');
    $menu.removeClass('has-active-item');
    
    if (hasActiveItem) {
        // Add helper class to menu
        $menu.addClass('has-active-item');
        
        // Update each first level item
        $firstLevelItems.each(function() {
            const $item = $(this);
            // Check if this item has an open dropdown
            if ($item.find('> .dropdown-menu.show').length > 0) {
                $item.addClass('is-active');
            } else {
                $item.addClass('is-inactive');
            }
        });
    } else {
        // If no first level is active, clear all second level states
        $menu.find('.dropdown-menu.depth_0 > li').removeClass('is-active is-inactive');
    }
}

 
 /**
 * Inicjalizacja sticky navbar
 */
 function navbarStickyInit() {
    try {
        // Motyw ma html/body height:100% + overflow-x:hidden, przez co to BODY
        // jest kontenerem scrollujacym - window.pageYOffset zawsze zwraca 0.
        const scroll = document.body.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
        const width = window.innerWidth;
        
        // Punkty załamania dla różnych szerokości ekranu
        const breakpoints = {
            992: 148.8,
            1200: 161.19,
            1366: 161.19,
            1460: 173.59,
            1900: 186,
        };
 
        // Znalezienie odpowiedniego breakpointa
        for (const [breakpoint, scrollValue] of Object.entries(breakpoints)) {
            if (width >= parseInt(breakpoint)) {
                const $content = $('#content');
                $content.toggleClass('sticky-active', scroll >= scrollValue);
                break;
            }
        }
    } catch (error) {
        console.error('Navbar sticky initialization error:', error);
    }
 }
 
 /**
 * Inicjalizacja handlerów zmiany rozmiaru okna
 */
 function initializeResizeHandlers() {
    let width = window.innerWidth;
    let resizeTimeout;
    
    $(window).on('resize', function() {
        // Debounce resize event
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newWidth = $(this).width();
            if (newWidth !== width) {
                width = newWidth;
                handleScreenSizeChange();
            }
        }, 250);
    });
 }
 
 /**
 * Obsługa zmiany rozmiaru ekranu
 */
 function handleScreenSizeChange() {
    try {
        if (window.matchMedia('(min-width: 992px)').matches) {
            resetToDesktopDefault();
        } else {
            resetToMobileDefault();
        }
    } catch (error) {
        console.error('Screen size change handling error:', error);
        // Fallback do podstawowych ustawień
        resetToBasicDefault();
    }
 }
 
 /**
 * Reset do ustawień domyślnych dla desktop
 */
 function resetToDesktopDefault() {
    navbarStickyInit();
    $('#navigation').removeClass('active');
    $('body').css('overflow-y', 'auto');
    
    const $toggler = $('#shop-sidebar-toggler');
    $toggler.find('span.open s').show();
    $toggler.find('span.close').hide();
    $('#shop-sidebar-content').show();
 }
 
 /**
 * Reset do ustawień domyślnych dla mobile
 */
 function resetToMobileDefault() {
    $('body').css('overflow-y', 'auto');
    $('#navigation').removeClass('active');
    $('#shop-sidebar-content').hide();
 }
 
/**
* Podstawowy reset (fallback)
*/
function resetToBasicDefault() {
   $('body').css('overflow-y', 'auto');
   $('#navigation, #shop-sidebar-content').hide();
}

// -----------------------------------------
// MEGA MENU FUNCTIONS
// -----------------------------------------

/**
 * Inicjalizacja Mega Menu dla Desktop
 */
function initializeMegaMenu() {
    if (!window.matchMedia('(min-width: 992px)').matches) {
        return;
    }

    const $megaMenuWrapper = $('#mega-menu-container');
    const $megaMenuTriggers = $('.mega-menu-trigger');
    const $megaMenuPanels = $('.mega-menu-panel');
    
    if (!$megaMenuWrapper.length || !$megaMenuTriggers.length) {
        return;
    }

    let hideTimeout;
    let isHoveringMenu = false;

    // Hover on menu trigger items
    $megaMenuTriggers.on('mouseenter', function() {
        clearTimeout(hideTimeout);
        const menuSlug = $(this).data('mega-menu');
        
        // Remove active class from all triggers and panels
        $megaMenuTriggers.removeClass('mega-menu-active');
        $megaMenuPanels.removeClass('active');
        
        // Add active class to current trigger
        $(this).addClass('mega-menu-active');
        
        // Show corresponding panel
        const $targetPanel = $(`.mega-menu-panel[data-menu-item="${menuSlug}"]`);
        if ($targetPanel.length) {
            $targetPanel.addClass('active');
            $megaMenuWrapper.addClass('active');
        }
    });

    $megaMenuTriggers.on('mouseleave', function() {
        if (!isHoveringMenu) {
            hideTimeout = setTimeout(() => {
                hideMegaMenu();
            }, 150);
        }
    });

    // Hover on mega menu wrapper
    $megaMenuWrapper.on('mouseenter', function() {
        clearTimeout(hideTimeout);
        isHoveringMenu = true;
    });

    $megaMenuWrapper.on('mouseleave', function() {
        isHoveringMenu = false;
        hideTimeout = setTimeout(() => {
            hideMegaMenu();
        }, 150);
    });

    // Click on menu trigger link - allow navigation
    $megaMenuTriggers.find('> a').on('click', function(e) {
        const href = $(this).attr('href');
        if (href && href !== '#') {
            // Allow default navigation
            return true;
        }
        e.preventDefault();
    });

    // Group click in mega menu (Level 2) - shows corresponding categories
    $('.mega-menu-group').on('click', function(e) {
        e.preventDefault();
        const $panel = $(this).closest('.mega-menu-panel');
        const groupIndex = $(this).data('group-index');
        
        // Update active group
        $panel.find('.mega-menu-group').removeClass('active');
        $(this).addClass('active');
        
        // Show corresponding category group, hide others
        $panel.find('.mega-menu-group-categories').removeClass('active');
        $panel.find('.mega-menu-group-categories[data-group-index="' + groupIndex + '"]').addClass('active');
    });

    // Helper function to hide mega menu
    function hideMegaMenu() {
        $megaMenuTriggers.removeClass('mega-menu-active');
        $megaMenuPanels.removeClass('active');
        $megaMenuWrapper.removeClass('active');
    }

    // Initialize navbar sticky
    navbarStickyInit();
    
    // Scroll handler (capture: scrolluje BODY, zdarzenie nie bąbelkuje)
    const throttledScroll = throttle(navbarStickyInit, 100);
    document.addEventListener('scroll', throttledScroll, { passive: true, capture: true });

    // Close mega menu when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('#main-navigation').length) {
            hideMegaMenu();
        }
    });
}

/**
 * Inicjalizacja dropdownów Mega Menu dla Mobile
 */
function initializeMegaMenuMobileDropdowns() {
    const $mobileMenus = $('#menu-mega-menu-mobile');
    
    if (!$mobileMenus.length) {
        return;
    }

    // Use capture phase to handle second level clicks BEFORE Bootstrap intercepts them
    document.addEventListener('click', function(e) {
        const target = e.target;
        const link = target.closest('a');
        
        // Check if click is on a second level item (inside depth_0 menu)
        if (link) {
            const parentLi = link.parentElement;
            const secondLevelMenu = link.closest('ul.dropdown-menu.depth_0');
            const mobileMenu = link.closest('#menu-mega-menu-mobile');
            
            // Only handle clicks inside mobile menu's second level
            if (secondLevelMenu && mobileMenu) {
                // Check if this item has children (third level)
                if (parentLi.classList.contains('menu-item-has-children')) {
                    // Prevent default and stop propagation
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Get the third level submenu
                    const submenu = parentLi.querySelector(':scope > ul.dropdown-menu');
                    const isCurrentlyOpen = submenu && submenu.classList.contains('show');
                    
                    // Close all sibling groups' submenus first
                    const siblingItems = secondLevelMenu.querySelectorAll(':scope > li.menu-item-has-children');
                    siblingItems.forEach(function(siblingLi) {
                        const siblingSubmenu = siblingLi.querySelector(':scope > ul.dropdown-menu');
                        const siblingLink = siblingLi.querySelector(':scope > a');
                        if (siblingSubmenu) {
                            siblingSubmenu.classList.remove('show');
                        }
                        if (siblingLink) {
                            siblingLink.setAttribute('aria-expanded', 'false');
                        }
                    });
                    
                    // Toggle the clicked group's submenu (open if it was closed)
                    if (submenu && !isCurrentlyOpen) {
                        submenu.classList.add('show');
                        link.setAttribute('aria-expanded', 'true');
                    }
                    
                    // Update second level states
                    updateMegaMenuSecondLevelStates(secondLevelMenu);
                    
                    // Update first level states
                    updateMegaMenuActiveStates($(mobileMenu));
                }
            }
        }
    }, true); // true = capture phase

    // Handle clicks anywhere to update first level states
    $(document).on('click', function() {
        setTimeout(function() {
            $mobileMenus.each(function() {
                updateMegaMenuActiveStates($(this));
            });
        }, 150);
    });

    // Handle clicks on third level items (depth_1)
    $mobileMenus.on('click', '.dropdown-menu.depth_1 > li > a', function(e) {
        // Allow navigation but prevent closing parent menus
        e.stopPropagation();
    });

    // Prevent clicks inside dropdown menus from closing parent dropdowns
    $mobileMenus.find('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });

    // Initial state check
    updateMegaMenuActiveStates($mobileMenus.first());
}

/**
 * Aktualizacja stanów drugiego poziomu Mega Menu (native JS)
 * @param {Element} secondLevelMenu - Element UL menu drugiego poziomu (depth_0)
 */
function updateMegaMenuSecondLevelStates(secondLevelMenu) {
    const items = secondLevelMenu.querySelectorAll(':scope > li');
    
    // Check if any item has open third level
    let hasOpenThirdLevel = false;
    items.forEach(function(item) {
        const submenu = item.querySelector(':scope > ul.dropdown-menu.show');
        if (submenu) {
            hasOpenThirdLevel = true;
        }
    });
    
    // Clear previous classes
    items.forEach(function(item) {
        item.classList.remove('is-active', 'is-inactive');
    });
    
    // Add classes if any third level is open
    if (hasOpenThirdLevel) {
        items.forEach(function(item) {
            const submenu = item.querySelector(':scope > ul.dropdown-menu.show');
            if (submenu) {
                item.classList.add('is-active');
            } else {
                item.classList.add('is-inactive');
            }
        });
    }
}

/**
 * Aktualizacja stanów aktywnych elementów Mega Menu
 * @param {jQuery} $menu - Element menu
 */
function updateMegaMenuActiveStates($menu) {
    const $firstLevelItems = $menu.children('li');
    
    // Check if any first level item has an open dropdown
    const hasActiveItem = $firstLevelItems.filter(function() {
        return $(this).find('> .dropdown-menu.show').length > 0;
    }).length > 0;
    
    // Always clear previous states first
    $firstLevelItems.removeClass('is-active is-inactive');
    $menu.removeClass('has-active-item');
    
    if (hasActiveItem) {
        // Add helper class to menu
        $menu.addClass('has-active-item');
        
        // Update each first level item
        $firstLevelItems.each(function() {
            const $item = $(this);
            // Check if this item has an open dropdown
            if ($item.find('> .dropdown-menu.show').length > 0) {
                $item.addClass('is-active');
            } else {
                $item.addClass('is-inactive');
            }
        });
    } else {
        // If no first level is active, clear all second level states
        $menu.find('.dropdown-menu.depth_0 > li').removeClass('is-active is-inactive');
    }
}



// WEBPACK FOOTER //
// ./scripts/common.js